module.exports = __webpack_public_path__ + "static/media/25.61bbe30f.svg";